import { LanguageType } from '@/custom-types';
import { RentChargeStatusOption, RentChargeTypeOption } from '@/graphql/generated';

export const rentChargeStatusMapper = (status: RentChargeStatusOption, language: LanguageType) => {
  const texts = {
    en: {
      NOT_RECEIVED: 'Not Received',
      PENDING: 'Pending',
      RECEIVED: 'Received',
      OVERDUE: 'Overdue',
    },
    es: {
      NOT_RECEIVED: 'No recibido',
      PENDING: 'Pendiente',
      RECEIVED: 'Recibido',
      OVERDUE: 'Vencido',
    }
  }

  return texts[language][status]
}

export const rentChargeTypeMapper = (type: RentChargeTypeOption, language: LanguageType) => {
  const texts = {
    en: {
      PET_DEPOSIT: 'Pet Deposit',
      RENT_INCOME: 'Rent Income',
      SECURITY_DEPOSIT: 'Security Deposit',
    },
    es: {
      PET_DEPOSIT: 'Deposito por Mascota',
      RENT_INCOME: 'Ingreso por Renta',
      SECURITY_DEPOSIT: 'Deposito de seguridad',
    }
  }

  return texts[language][type]
}
